import { z } from 'zod';
import { CampaignGoalType } from '../ad-builder/CampaignGoalType';
import { SupportType } from './Funnel';
import { StageTargetDTO } from './FunnelStage';
import {
  exampleFunnelStageGroupConfig,
  FunnelStageGroupConfigDTO,
} from './FunnelStageGroupConfig';

export const FunnelStageConfigDTO = z.object({
  id: z.number().optional(),
  name: z.string(),
  desc: z.string(),
  icon: z.string(),
  support: z.array(z.nativeEnum(SupportType)),
  groups: z.array(FunnelStageGroupConfigDTO),
  estimate: z.boolean(),
  order: z.number(),
  conversion_name: z.string().refine((str) => str !== ''),
  show_total: z.boolean(),
  is_kpi: z.boolean(),
  is_sub_kpi: z.boolean(),
  show_overview: z.boolean(),
  cost_per_metric: z.number(),
  data_sources_id: z.union([z.number(), z.null()]).optional(),
  campaign_goal: z.union([z.nativeEnum(CampaignGoalType), z.null()]).optional(),
  stage_target: z.union([StageTargetDTO, z.null()]).optional(),
  est_conversion_name: z.union([z.string(), z.null()]),
});

export type FunnelStageConfig = z.TypeOf<typeof FunnelStageConfigDTO>;

export const exampleFunnelStageConfig: FunnelStageConfig = {
  name: 'Funnel Stage',
  desc: 'Description',
  icon: 'fa-person',
  support: [SupportType.Conversions],
  groups: [exampleFunnelStageGroupConfig],
  estimate: true,
  order: 1,
  conversion_name: 'Conversions',
  est_conversion_name: 'Estimated Conversions',
  show_total: true,
  is_kpi: true,
  is_sub_kpi: false,
  show_overview: true,
  cost_per_metric: 1,
};
